import React, { useState } from 'react';
import { TextField, Button, Typography, Card, CardContent, InputAdornment, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authServices } from '../../services/authentication/authServices';

const ChangePassword = () => {

    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [passwordError, setPasswordError] = useState('');
    const navigate = useNavigate();

    const validatePasswordRules = (password) => {
        const hasCapital = /[A-Z]/.test(password);
        const hasNumber = /[0-9]/.test(password);
        const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        
        if (!hasCapital) return "Password must contain at least one capital letter.";
        if (!hasNumber) return "Password must contain at least one number.";
        if (!hasSpecial) return "Password must contain at least one special character.";
        return "";
    };

    const handleNewPasswordChange = (e) => {
        const value = e.target.value;
        setNewPassword(value);
        
        const validationError = validatePasswordRules(value);
        setPasswordError(validationError);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            setError("New password and confirm password do not match.");
            setTimeout(() => setError(null), 4000);
            return;
        }

        const validationError = validatePasswordRules(newPassword);
        if (validationError) {
            setError(validationError);
            setTimeout(() => setError(null), 4000);
            return;
        }

        if (oldPassword === newPassword) {
            setError("New password cannot be the same as current password");
            setTimeout(() => setError(null), 4000);
            return;
        }

        const passwordData = {
            oldPassword,
            newPassword
        };

        authServices.changePassword(passwordData)
            .then((response) => {
                setSuccessMessage("Password changed successfully! Redirecting to login...");
                setOldPassword('');
                setNewPassword('');
                setConfirmPassword('');
                localStorage.setItem("passwordChanged", "true");
                
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                window.location.href = '/login';
            })
            .catch((error) => {

                if (error.response) {
                    switch (error.response.status) {
                        case 400:
                            setError("Invalid old password.");
                            break;
                        case 500:
                            setError("Server error. Please try again later.");
                            break;
                        default:
                            setError("Something went wrong.");
                    }
                } else {
                    setError("Network issue. Please check your internet connection.");
                }
                setTimeout(() => setError(null), 4000);
            });
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: 'linear-gradient(to right, #045864, #FF6B6B)',
            fontFamily: 'Poppins, sans-serif',
        }}>
            <Card sx={{ width: 400, padding: '1.25rem', borderRadius: '1rem', boxShadow: 3, backgroundColor: '#ffffff' }}>
                <CardContent>
                    <Typography variant="h3" align="center" gutterBottom
                        sx={{ fontWeight: 700, fontSize: '2rem', color: '#045864', letterSpacing: '2px' }}
                    >
                        Change Password
                    </Typography>

                    {successMessage && (
                        <Alert variant="filled" severity="success" sx={{ marginTop: 2 }}>
                            {successMessage}
                        </Alert>
                    )}

                    {error && (
                        <Alert variant="outlined" severity="error" sx={{ marginTop: 2 }}>
                            {error}
                        </Alert>
                    )}

                    <form onSubmit={handleSubmit}>

                        {/* Old Password */}
                        <TextField
                            label="Old Password"
                            variant="outlined"
                            fullWidth
                            type="password"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            required
                            margin="normal"
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <i className="fa fa-lock" style={{ color: '#045864' }}></i>
                                        </InputAdornment>
                                    ),
                                }
                            }}
                        />

                        {/* New Password */}
                        <TextField
                            label="New Password"
                            variant="outlined"
                            fullWidth
                            type="password"
                            value={newPassword}
                            onChange={handleNewPasswordChange}
                            required
                            margin="normal"
                            error={!!passwordError}
                            helperText={passwordError}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <i className="fa fa-lock" style={{ color: '#045864' }}></i>
                                        </InputAdornment>
                                    ),
                                }
                            }}
                        />

                        {/* Confirm Password */}
                        <TextField
                            label="Confirm New Password"
                            variant="outlined"
                            fullWidth
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            margin="normal"
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <i className="fa fa-lock" style={{ color: '#045864' }}></i>
                                        </InputAdornment>
                                    ),
                                }
                            }}
                        />

                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{ marginTop: 2, padding: '0.75rem', fontSize: '1rem', textTransform: 'none' }}
                        >
                            Update Password
                        </Button>

                        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                            <Button
                                variant="text"
                                onClick={() => {
                                    localStorage.removeItem('accessToken');
                                    localStorage.removeItem('refreshToken');
                                    window.location.href = '/login';
                                }}
                                sx={{ color: '#045864', textTransform: 'none', fontSize: '0.875rem' }}
                            >
                                Back to Login?
                            </Button>
                        </div>

                    </form>

                </CardContent>
            </Card>
        </div>
    );
};

export default ChangePassword;